import { produce } from 'immer';

import { textDiff } from 'app/utils/textDiff';
import { NodeT } from 'fable/flowEditor';

export function actionDiff(actions: NodeT[], actionsBefore: NodeT[]): string {
  const cleanForDiff = (action: NodeT) => {
    return produce<Partial<NodeT>>(action, (draft) => {
      delete draft.childIds;
      delete draft.isEditable;
      delete draft.badges;
      delete draft.isRemovable;
      delete draft.text;
    });
  };
  const before = JSON.stringify(actionsBefore.map(cleanForDiff), null, 2);
  const after = JSON.stringify(actions.map(cleanForDiff), null, 2);
  return textDiff(before, after);
}
